// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9373) return "static/chunks/9373-ec4c7ed97e6b31ce.js";
	if (chunkId === 9179) return "static/chunks/9179-0b282149b144de5c.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"929":"3c66e69ffb2ba180","4143":"4850787032139e83","7171":"49c4b6d7bf6ac9dc","7618":"8637804ec278d050"}[chunkId] + ".js";
};